export const fetchClaimsSuccessHandler = (state, {
  productId,
  claims
}) => ({
  ...state,
  products: {
    ...state.products,
    [productId]: {
      ...state.products[productId],
      claims
    }
  }
});
export const checkSmdFileValidityHandler = (state, args) => ({
  ...state,
  products: {
    ...state.products,
    [args.productId]: {
      ...state.products[args.productId],
      smd: {
        ...args
      }
    }
  }
});